import {AfterViewInit, Component, Inject, Optional, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-edit-program-text',
  templateUrl: './edit-program-text.component.html',
  styleUrls: ['./edit-program-text.component.scss']
})
export class EditProgramTextComponent {

  constructor(
    private dialogRef: MatDialogRef<EditProgramTextComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data:any,
  ) {
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  saveDetails() {
    this.dialogRef.close(this.data.fieldText)
  }
}
